import "core-js/modules/es6.array.slice.js";
export default function capitalize(string) {
  return "".concat(string.charAt(0).toUpperCase()).concat(string.slice(1));
}


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-transition/src/util/capitalize.js